import React from 'react';

import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import { Box, Flex, Grid, Text } from '@atlaskit/primitives/compiled';

const styles = cssMap({
	gridStyles: {
		height: '100%',
	},
	flexStyles: {
		textAlign: 'center',
	},
});

export type ErrorLayoutProps = {
	action?: React.ReactNode;
	heading: React.ReactNode;
	illustration?: React.ReactNode;
	message?: React.ReactNode;
	testId?: string;
};

export const ErrorLayout = ({
	heading,
	message,
	action,
	illustration,
	testId,
}: ErrorLayoutProps): React.JSX.Element => {
	return (
		<Grid justifyContent="center" xcss={styles.gridStyles} testId={testId}>
			<Flex
				direction="column"
				justifyContent="center"
				alignItems="center"
				xcss={styles.flexStyles}
				gap="space.100"
			>
				{illustration && <Box>{illustration}</Box>}
				<Heading size="large">{heading}</Heading>
				{message && <Text color="color.text.subtle">{message}</Text>}
				{action && <Box>{action}</Box>}
			</Flex>
		</Grid>
	);
};
